import type {CreateProps} from '@refinedev/mui';
import {Edit as EditMui} from '@refinedev/mui';
import {FC, ReactNode} from 'react';

import {CustomEdit} from '@components/crud/_partial/custom-edit';

type CustomEditProps = {
  auto?: boolean;
  title?: string | ReactNode;
} & Omit<CreateProps, 'title'>;

/**
 * `<Edit>` provides us a layout for displaying the page.
 * It does not contain any logic but adds extra functionalities like a refresh button.
 *
 * @see {@link https://refine.dev/docs/ui-frameworks/mui/components/basic-views/edit} for more details.
 */
export const Edit: FC<CustomEditProps> = ({auto = false, ...props}) => {
  return auto ? <EditMui {...props} /> : <CustomEdit {...props} />;
};
